<div class="container mt-5 pt-5" style="margin-bottom: 15rem !important">
  <div class="row">
    <div class="col-sm-2"></div>

    <div class="col-sm-8">
      <div style="text-align: justify">
        <h1 class="text-center" style="color: #c41e3a; margin-bottom: 2rem;">
          AUTORIZACIÓN DE TRATAMIENTO DE DATOS PERSONALES PARA USOS ADICIONALES / COMERCIALES
        </h1>

              <div class="section">
                <p class="text-justify">
                  <strong>
                    En cumplimiento de la Ley N° 29733, Ley de Protección de Datos
                    Personales, su Reglamento y las disposiciones sobre la prohibición
                    de comunicaciones no solicitadas, el titular de los datos (en
                    adelante, el USUARIO) otorga su consentimiento previo, expreso e
                    informado a la Empresa Peruana de Servicios Editoriales S.A. -
                    Editora Perú (en adelante, EDITORA PERÚ), con RUC N° 20100072751,
                    para el tratamiento de sus datos personales, conforme a las
                    siguientes condiciones:
                  </strong>
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  1. Finalidades adicionales y comerciales del tratamiento
                </h5>
                <p class="text-justify">
                  <strong>
                    El USUARIO autoriza a EDITORA PERÚ para que, de manera directa o a
                    través de terceros encargados, pueda tratar sus datos personales
                    con las siguientes finalidades adicionales, distintas a las
                    necesarias para la prestación de los servicios principales:
                  </strong>
                </p>
                <ol type="a">
                  <li class="text-justify">
                    Remitir información publicitaria, promociones y ofertas comerciales
                    vinculadas a los productos y servicios editoriales, periodísticos y
                    de artes gráficas de la institución, tales como los correspondientes
                    al Diario Oficial El Peruano, Agencia Peruana de Noticias Andina,
                    Museo Gráfico, Fondo Editorial, PGA, Cendoc Digital.
                  </li>
                  <li class="text-justify">
                    Gestionar y remitir invitaciones a eventos, ferias de libros,
                    exposiciones, actividades culturales, seminarios y demás actividades
                    institucionales organizadas por Editora Perú.
                  </li>
                  <li class="text-justify">
                    Realizar actividades de prospección comercial, estudios de mercado y
                    encuestas de satisfacción, con la finalidad de mejorar la calidad de
                    los productos y servicios ofrecidos por Editora Perú.
                  </li>
                  <li class="text-justify">
                    Ejecutar procesos de segmentación y perfilamiento publicitario
                    mediante herramientas automatizadas, con la finalidad de adaptar la
                    oferta informativa y comercial a los intereses del USUARIO, así como
                    elaborar reportes estadísticos, cuantitativos, cualitativos o
                    históricos y perfiles anonimizados de usuarios, en base al historial
                    de navegación, consultas o compras de productos y servicios de
                    Editora Perú.
                  </li>
                </ol>
                <p class="text-justify">
                  <strong>
                    El USUARIO declara conocer que los procesos de segmentación y
                    perfilamiento antes mencionados no producen efectos jurídicos ni
                    afectan de manera significativa sus derechos.
                  </strong>
                </p>
                <ol type="a" start="5">
                  <li class="text-justify">
                    Enviar al USUARIO publicidad, promociones y ofertas comerciales de
                    empresas terceras que mantengan vínculos comerciales o alianzas con
                    Editora Perú (en adelante los TERCEROS).
                  </li>
                </ol>
                <p class="text-justify">
                  La presente autorización comprende de manera independiente:
                </p>
                <ul>
                  <li>el envío de comunicaciones comerciales de EDITORA PERÚ; y</li>
                  <li>el envío de comunicaciones comerciales de TERCEROS.</li>
                </ul>
                <p class="text-justify">
                  El tratamiento de datos personales se realizará conforme a los
                  principios de legalidad, consentimiento, finalidad, proporcionalidad,
                  calidad, seguridad y disposición de recurso, establecidos en la Ley
                  N.° 29733 y en los criterios interpretativos de la Autoridad Nacional
                  de Protección de Datos Personales.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  2. Canales de Comunicación
                </h5>
                <p class="text-justify">
                  <strong>
                    El USUARIO autoriza a EDITORA PERÚ a contactarlo, para las
                    finalidades señaladas, a través de llamadas telefónicas, mensajes de
                    texto (SMS), aplicaciones de mensajería instantánea (WhatsApp),
                    correos electrónicos, notificaciones "push" u otros medios de
                    comunicación electrónicos o físicos equivalentes.
                  </strong>
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  3. Banco de datos, transferencia y encargados de tratamiento
                </h5>
                <p class="text-justify">
                  <strong>
                    Los datos personales serán incorporados en el banco de titularidad
                    de EDITORA PERÚ denominado:
                  </strong>
                </p>
                <p class="text-justify">
                  <strong>
                    GESPO - SISTEMA DE GESTIÓN DE PUBLICACIONES (TABLA DE CLIENTES)
                    inscrito en el Registro Nacional de Protección de Datos Personales
                    con Código N° 00160 con domicilio en Av. Alfonso Ugarte N.° 873,
                    Cercado de Lima.
                  </strong>
                </p>
                <p class="text-justify">
                  <strong>
                    El USUARIO autoriza que sus datos personales puedan ser tratados por
                    proveedores tecnológicos y proveedores de servicios de EDITORA PERÚ,
                    en calidad de encargados de tratamiento, exclusivamente para el
                    cumplimiento de las finalidades descritas en la presente
                    autorización.
                  </strong>
                </p>
                <p class="text-justify">
                  Asimismo, el USUARIO autoriza que sus datos personales puedan ser
                  comunicados a los TERCEROS, para que estos puedan enviarle
                  directamente información publicitaria y promociones de sus propios
                  productos o servicios, conforme a las finalidades descritas en el
                  numeral 1.e) del presente documento.
                </p>
                <p class="text-justify">
                  EDITORA PERÚ adoptará las medidas necesarias para que dichos
                  encargados de tratamiento y terceros receptores respeten la normativa
                  vigente en materia de protección de datos personales.
                </p>
                <p class="text-justify">
                  Los TERCEROS encargados del tratamiento deberán implementar medidas de
                  seguridad técnicas, organizativas y legales equivalentes o superiores
                  a las aplicadas por Editora Perú, siendo responsables solidarios
                  frente a cualquier incumplimiento imputable a su actuación.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  4. Plazo de conservación, revocatoria y derechos ARCO
                </h5>
                <p class="text-justify">
                  <strong>
                    La presente autorización tendrá una vigencia de diez (10) años o
                    hasta que el USUARIO revoque su consentimiento, lo que ocurra
                    primero.
                  </strong>
                </p>
                <p class="text-justify">
                  Se informa al USUARIO que la negativa a otorgar la presente
                  autorización no condiciona ni afecta la prestación de los servicios
                  principales que brinda Editora Perú.
                </p>
                <p class="text-justify">
                  <strong>
                    El USUARIO podrá ejercer, en cualquier momento y de forma gratuita,
                    sus derechos de acceso, rectificación, cancelación y oposición
                    (derechos ARCO), así como revocar el presente consentimiento,
                    mediante el envío de una solicitud al correo electrónico:
                    <a href="mailto:datospersonales@editoraperu.com.pe">
                      datospersonales&#64;editoraperu.com.pe
                    </a>
                  </strong>
                </p>
                <p class="text-justify">
                  o de manera presencial en las oficinas de EDITORA PERÚ, ubicadas en
                  Av. Alfonso Ugarte N.° 873, Cercado de Lima.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  5. Información adicional
                </h5>
                <p class="text-justify">
                  El USUARIO puede conocer información más detallada sobre el
                  tratamiento de sus datos personales, las medidas de seguridad
                  aplicables y los derechos que le asisten, accediendo a la Política de
                  Privacidad de EDITORA PERÚ, disponible en el siguiente enlace:
                  <a
                    href="https://www.editoraperu.com.pe/EditoraP/ProteccionDatosPersonales.html"
                    target="_blank"
                  >
                    https://www.editoraperu.com.pe/EditoraP/ProteccionDatosPersonales.html
                  </a>
                </p>
                <p class="text-justify">
                  Editora Perú podrá requerir información, evidencias de cumplimiento y
                  realizar verificaciones respecto de los encargados y terceros
                  receptores, a efectos de atender requerimientos de la Autoridad
                  Nacional de Protección de Datos Personales, Contraloría General de la
                  República o INDECOPI.
                </p>
              </div>
      </div>
    </div>

    <div class="col-sm-2"></div>
  </div>
</div>
